import { configureStore } from '@reduxjs/toolkit';

import authSlice from '../slices/authSlice.js'
import settingsSlice from '../slices/settingsSlice.js'
import dataSlice from '../slices/dataSlice.js'
import uiSlice from '../slices/uiSlice.js'
import chouseSlice from '../slices/chouseSlice';
import emailReducer from '../slices/emailSlice';

export const store = configureStore({
    reducer: {
      auth: authSlice,
      settings: settingsSlice,
      data: dataSlice,
      uislice: uiSlice,
      emails: emailReducer,
      chouse: chouseSlice,
    }
  });

export default store;